import expensesAxiosInstance from './expensesAxiosInstance';
import { API_ENDPOINTS } from '../config/api.config';

const { EXPENSES } = API_ENDPOINTS;

export const expensesApi = {
  login: (credentials) => expensesAxiosInstance.post(EXPENSES.LOGIN, credentials),
  logout: () => expensesAxiosInstance.post(EXPENSES.LOGOUT),
  getToday: () => expensesAxiosInstance.get(EXPENSES.LIST),
  add: (data) => expensesAxiosInstance.post(EXPENSES.LIST, data),
  update: (id, data) => expensesAxiosInstance.patch(EXPENSES.DETAIL(id), data),
  remove: (id) => expensesAxiosInstance.delete(EXPENSES.DETAIL(id)),
  getCategories: (q) => expensesAxiosInstance.get(EXPENSES.CATEGORIES, { params: { q } }),
  // Past titles + Money-section dues (chit/salary/rent) for the title field
  getTitleSuggestions: (q) =>
    expensesAxiosInstance.get(EXPENSES.TITLE_SUGGESTIONS, { params: { q } }),
  // Pay a Money commitment from the expense form — creates the Expense AND
  // runs the chit/bill's balance down in one go.
  payMoney: (id, body) => expensesAxiosInstance.post(API_ENDPOINTS.MONEY.PAY(id), body),

  // Cash refunds to pay — params: { status: 'pending'|'paid'|'all', from, to }
  getCashRefunds: (params) => expensesAxiosInstance.get(EXPENSES.CASH_REFUNDS, { params }),
  markCashRefundPaid: (id, paid) => expensesAxiosInstance.patch(EXPENSES.CASH_REFUND_PAY(id), { paid }),

  // Everything still to pay (refunds + OSM + planned + chit) — period: day|week|month
  getPayables: (period = 'month') =>
    expensesAxiosInstance.get(EXPENSES.PAYABLES, { params: { period } }),
};
